import { AutoCompleteOptionItem } from '@autocomplete-with-controls';

export function mapToOptions(data: any[]): Array<AutoCompleteOptionItem<any>> {
  return data.map((address) => ({ option: address }));
}
